import { createI18n } from "vue-i18n";

import en from "./en.json";
import et from "./et.json";
import fi from "./fi.json";
import lv from "./lv.json";
import lt from "./lt.json";
import ru from "./ru.json";

export const SUPPORTED_LOCALES = ["en", "et", "ru", "fi", "lv", "lt"] as const;
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

function resolveInitialLocale(): SupportedLocale {
  if (typeof window === "undefined") return "en";
  const stored = window.localStorage.getItem("locale");
  if (stored && SUPPORTED_LOCALES.includes(stored as SupportedLocale)) {
    return stored as SupportedLocale;
  }
  return "en";
}

const i18n = createI18n({
  legacy: false,
  locale: resolveInitialLocale(),
  fallbackLocale: "en",
  messages: {
    en,
    et,
    ru,
    fi,
    lv,
    lt,
  },
});

if (typeof document !== "undefined") {
  document.documentElement.lang = i18n.global.locale.value;
}

export function setLocale(locale: SupportedLocale) {
  i18n.global.locale.value = locale;
  if (typeof window !== "undefined") {
    window.localStorage.setItem("locale", locale);
  }
  if (typeof document !== "undefined") {
    document.documentElement.lang = locale;
  }
}

export default i18n;
